import { Button } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface WorkspaceWhitelistRulesHeaderProps {
  onAddClick: () => void;
}

export const WorkspaceWhitelistRulesHeader = ({
  onAddClick,
}: WorkspaceWhitelistRulesHeaderProps) => {
  const { t } = useTranslation('admin');

  return (
    <div className="flex items-center justify-between gap-2xl">
      <div className="flex flex-col items-start">
        <h2 className="text-base font-medium leading-6 text-foreground">
          {t('admin.workspaceWhitelistRulesHeader.workspaceRules')}
        </h2>
        <p className="text-body-md text-foreground-subtle">
          {t('admin.workspaceWhitelistRulesHeader.restrictSpecificWorkspacesToUse')}
        </p>
      </div>
      <Button onClick={onAddClick}>
        {t('admin.workspaceWhitelistRulesHeader.addRule')}
        <PlusIcon />
      </Button>
    </div>
  );
};
